var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCourseQuicklearn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.722,
    height: 40.129,
    viewBox: "0 0 53.722 40.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M280.163,126.085H230.642a1.6,1.6,0,0,0-1.6,1.6v30.267a1.6,1.6,0,0,0,1.6,1.6h20.417v3.776h-6.12v1.886h20.927v-1.886h-6.121v-3.776h20.418a1.6,1.6,0,0,0,1.6-1.6V127.685A1.6,1.6,0,0,0,280.163,126.085Zm-47.922,30.267V129.285h46.322v27.067Z",
    transform: "translate(-229.042 -126.085)",
    fill: "#525252",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338",
    transform: "translate(1.443 -4.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(10 13.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M29.62,28.74a7.02,7.02,0,1,0-7.02-7.02h0A7.174,7.174,0,0,0,29.62,28.74Zm0-11.659a4.638,4.638,0,1,1-4.638,4.638h0A4.89,4.89,0,0,1,29.62,17.082Z",
    transform: "translate(-6.805 -12.694)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M16.779,20.158h6.769a5.331,5.331,0,0,1,.251-1.379c.125-.376.251-1.379.5-1.379H16.779a1.379,1.379,0,1,0,0,2.758Z",
    transform: "translate(-8.631 -12.009)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M13.979,22.833h10.4a10.858,10.858,0,0,0-.251-1.254V20.2H13.979A1.391,1.391,0,0,0,12.6,21.579a1.373,1.373,0,0,0,1.379,1.254Z",
    transform: "translate(-9.341 -11.299)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M11.379,25.558H26.673c.125,0,.251-.125.376-.125a4.5,4.5,0,0,1-.878-1.254,2.783,2.783,0,0,1-.627-1.379H11.379a1.379,1.379,0,0,0,0,2.758Z",
    transform: "translate(-10 -10.639)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1986",
    "data-name": "Rectangle 1986",
    width: 3.385,
    height: 1.379,
    transform: "translate(21.311)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1987",
    "data-name": "Rectangle 1987",
    width: 1.379,
    height: 4.012,
    transform: "translate(32.063 18.491)",
    fill: "#525252"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseQuicklearn);
export default __webpack_public_path__ + "static/media/icon_course_quicklearn.04f92f61c4fc8ed8c65a6ecc298dccab.svg";
export { ForwardRef as ReactComponent };